import { render, staticRenderFns } from "./updateServicesDetail.vue?vue&type=template&id=31b6ac95&scoped=true"
import script from "./updateServicesDetail.vue?vue&type=script&lang=js"
export * from "./updateServicesDetail.vue?vue&type=script&lang=js"
import style0 from "./updateServicesDetail.vue?vue&type=style&index=0&id=31b6ac95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b6ac95",
  null
  
)

export default component.exports